// import _ from "lodash";
import React from "react";
import Spinner from "../../../../../../../utils/Spinner";
import ReactTable from "react-table";

const ProfilingMetrics = (props) => {
  const pfdata = props.data;
  const fetching = props.fetching;

  return (
    <>
      {" "}
      {fetching ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner />
        </div>
      ) : (
        <ReactTable
          data={pfdata}
          sortable={true}
          size="sm"
          showPagination={true}
          className="valid__m"
          columns={[
            {
              Header: () => (
                <div className="column__table__header">Metric Key</div>
              ),
              accessor: "metricKey",
            },
            {
              Header: () => (
                <div className="column__table__header">Metric Value</div>
              ),
              accessor: "metricValue",
            },
          ]}
          defaultPageSize={5}
        />
      )}
    </>
  );
};

export default ProfilingMetrics;
